let goods = [
  {
    path: 'goodsMgt',
    meta: {
      title: '商品管理',
      breadcrumb: true
    },
    component: {
      name: 'goodsMgt',
      template: '<router-view></router-view>'
    },
    children: [
      {
        path: '',
        meta: {
          title: '商品管理',
        },
        component: (resolve) => require(['@/views/plat/goodsManagement/goodsMgt'], resolve)
      },
      {
        path: 'newAdd',
        meta: {
          title: "新增",
          breadcrumb: true,
        },
        component: (resolve) => require(['@/views/plat/goodsManagement/goodsMgt/children/newAdd'], resolve)
      },
      {
        path: 'editor',
        meta: {
          title: "编辑",
          breadcrumb: true,
        },
        component: (resolve) => require(['@/views/plat/goodsManagement/goodsMgt/children/editor'], resolve)
      },
      {
        path: 'purchase',
        meta: {
          title: "限购活动",
          breadcrumb: true,
        },
        component: (resolve) => require(['@/views/plat/goodsManagement/goodsMgt/children/purchase'], resolve)
      },
      {
        path: 'productGift',
        meta: {
          title: "赠品管理",
          breadcrumb: true,
        },
        component: (resolve) => require(['@/views/plat/goodsManagement/goodsMgt/children/productGift'], resolve)
      },
    ]
  },
  {
    path: 'rwllClassify',
    meta: {
      title: '视力调理分类',
      breadcrumb: true
    },
    component: {
      name: 'rwllClassify',
      template: '<router-view></router-view>'
    },
    children: [
      {
        path: '',
        meta: {
          title: '视力调理分类',
        },
        component: (resolve) => require(['@/views/plat/goodsManagement/rwllClassify'], resolve),
      },
      {
        path: 'setGoods',
        meta: {
          title: "绑定商品",
          breadcrumb: true,
        },
        component: (resolve) => require(['@/views/plat/goodsManagement/rwllClassify/setGoods'], resolve)
      }
    ]
  },
  {
    path: 'yyslClassify',
    meta: {
      title: 'AI电商分类',
      breadcrumb: true
    },
    component: {
      name: 'yyslClassify',
      template: '<router-view></router-view>'
    },
    children: [
      {
        path: '',
        meta: {
          title: 'AI电商分类',
        },
        component: (resolve) => require(['@/views/plat/goodsManagement/yyslClassify'], resolve)
      },
      {
        path: 'setGoods',
        meta: {
          title: "绑定商品",
          breadcrumb: true,
        },
        component: (resolve) => require(['@/views/plat/goodsManagement/yyslClassify/setGoods'], resolve)
      }
    ]
  },
  {
    path: 'dqzgClassify',
    meta: {
      title: '向内调理分类',
      breadcrumb: true
    },
    component: {
      name: 'dqzgClassify',
      template: '<router-view></router-view>'
    },
    children: [
      {
        path: '',
        meta: {
          title: '向内调理分类',
        },
        component: (resolve) => require(['@/views/plat/goodsManagement/dqzgClassify'], resolve)
      },
      {
        path: 'setGoods',
        meta: {
          title: "绑定商品",
          breadcrumb: true,
        },
        component: (resolve) => require(['@/views/plat/goodsManagement/dqzgClassify/setGoods'], resolve)
      }
    ]
  },
  {
    path: 'yhfwClassify',
    meta: {
      title: '眼部养护分类',
      breadcrumb: true
    },
    component: {
      name: 'yhfwClassify',
      template: '<router-view></router-view>'
    },
    children: [
      {
        path: '',
        meta: {
          title: '眼部养护分类',
        },
        component: (resolve) => require(['@/views/plat/goodsManagement/yhfwClassify'], resolve)
      },
      {
        path: 'setGoods',
        meta: {
          title: "绑定商品",
          breadcrumb: true,
        },
        component: (resolve) => require(['@/views/plat/goodsManagement/yhfwClassify/setGoods'], resolve)
      }
    ]
  },
  {
    path: 'yxyyClassify',
    meta: {
      title: '视力防控分类',
      breadcrumb: true
    },
    component: {
      name: 'yxyyClassify',
      template: '<router-view></router-view>'
    },
    children: [
      {
        path: '',
        meta: {
          title: '视力防控分类',
        },
        component: (resolve) => require(['@/views/plat/goodsManagement/yxyyClassify'], resolve)
      },
      {
        path: 'setGoods',
        meta: {
          title: "绑定商品",
          breadcrumb: true,
        },
        component: (resolve) => require(['@/views/plat/goodsManagement/yxyyClassify/setGoods'], resolve)
      }
    ]
  },
  {
    path: 'sltlClassify',
    meta: {
      title: '食疗调理分类',
      breadcrumb: true
    },
    component: {
      name: 'sltlClassify',
      template: '<router-view></router-view>'
    },
    children: [
      {
        path: '',
        meta: {
          title: '食疗调理分类',
        },
        component: (resolve) => require(['@/views/plat/goodsManagement/sltlClassify'], resolve)
      },
      {
        path: 'setGoods',
        meta: {
          title: "绑定商品",
          breadcrumb: true,
        },
        component: (resolve) => require(['@/views/plat/goodsManagement/sltlClassify/setGoods'], resolve)
      }
    ]
  },
  {
    path: 'mwwdProduct',
    meta: {
      title: '云仓商品管理',
      breadcrumb: true
    },
    component: {
      name: 'mwwdProduct',
      template: '<router-view></router-view>'
    },
    children: [
      {
        path: '/',
        meta: {
          title: '云仓商品管理',
        },
        component: (resolve) => require(['@/views/plat/goodsManagement/mwwdProduct'], resolve)
      },
      {
        path: 'operating',
        meta: {
          title: "新增",
          breadcrumb: true,
        },
        component: (resolve) => require(['@/views/plat/goodsManagement/mwwdProduct/operating'], resolve)
      },
      {
        path: 'productGroup',
        meta: {
          title: "打包产品",
          breadcrumb: true,
        },
        component: (resolve) => require(['@/views/plat/goodsManagement/mwwdProduct/productGroup'], resolve)
      }
    ]
  },
  {
    path: 'activationCode',
    meta: {
      title: '光明使者激活码',
      breadcrumb: true
    },
    component: {
      name: 'activationCode',
      template: '<router-view></router-view>'
    },
    children: [
      {
        path: '',
        meta: {
          title: '光明使者激活码',
        },
        component: (resolve) => require(['@/views/plat/goodsManagement/activationCode'], resolve)
      },
      {
        path: 'actionPage',
        meta: {
          title: "新增",
          breadcrumb: true,
        },
        component: (resolve) => require(['@/views/plat/goodsManagement/activationCode/actionPage'], resolve)
      },
      {
        path: 'detail',
        meta: {
          title: "详情",
          breadcrumb: true,
        },
        component: (resolve) => require(['@/views/plat/goodsManagement/activationCode/detail'], resolve)
      }
    ]
  },
  {
    path: 'activateCodeList',
    meta: {
      title: '激活码列表',
      breadcrumb: true
    },
    component: {
      name: 'activateCodeList',
      template: '<router-view></router-view>'
    },
    children: [
      {
        path: '',
        meta: {
          title: '激活码列表',
        },
        component: (resolve) => require(['@/views/plat/goodsManagement/activateCodeList'], resolve)
      },
    ]
  },
]

export default {
  path: '/goodsManagement',
  redirect: '/goodsManagement/goodsMgt',
  meta: {
      title: "商品管理",
      breadcrumb: true
  },
  component: {
      name: 'goodsManagement',
      template: '<router-view></router-view>'
  },
  children: goods
}


// WEBPACK FOOTER //
// ./src/router/goodsManagement.js